<h1>Vendor Products</h1>
<nav mat-tab-nav-bar [tabPanel]="tabs">
  <a mat-tab-link *ngFor="let link of links" (click)="gotoTab(link.link)"
     [active]="activeLink == link">{{link.title}}</a>
</nav>
<app-vendor-pending-transfers-page *ngIf="activeLink?.title === 'Vendor Pending Transfers'"></app-vendor-pending-transfers-page>
<app-vendor-completed-transfers-page *ngIf="activeLink?.title === 'Vendor Completed Transfers'"></app-vendor-completed-transfers-page>
<mat-tab-nav-panel #tabs></mat-tab-nav-panel>
